var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllocatedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.25C14 22.7018 16.7982 25.5 20.25 25.5C23.7018 25.5 26.5 22.7018 26.5 19.25C26.5 15.7982 23.7018 13 20.25 13C16.7982 13 14 15.7982 14 19.25ZM14 19.25C14 17.8427 14.4651 16.5441 15.25 15.4994V4.25M14 19.25C14 20.2817 14.25 21.255 14.6927 22.1127C13.6396 23.0022 11.2073 23.625 8.375 23.625C4.57804 23.625 1.5 22.5057 1.5 21.125V4.25M15.25 4.25C15.25 5.63071 12.172 6.75 8.375 6.75C4.57804 6.75 1.5 5.63071 1.5 4.25M15.25 4.25C15.25 2.86929 12.172 1.75 8.375 1.75C4.57804 1.75 1.5 2.86929 1.5 4.25M1.5 15.5C1.5 16.8807 4.57804 18 8.375 18C11.1113 18 13.4742 17.4187 14.5808 16.5772M15.25 9.875C15.25 11.2557 12.172 12.375 8.375 12.375C4.57804 12.375 1.5 11.2557 1.5 9.875",
    stroke: "#4945FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllocatedIcon);
export default __webpack_public_path__ + "static/media/allocated_icon.1009a18b6b80a2139f421d4424adbaf6.svg";
export { ForwardRef as ReactComponent };